import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { getMainSiteUrl, IS_LANDING } from "../../constants/appConfig";
import { scrollToTopInstant } from "../../utils/scroll";

export function getNavHref(to) {
  if (!IS_LANDING) return to;
  const mainSite = getMainSiteUrl();
  return `${mainSite}${to.startsWith("/") ? to : `/${to}`}`;
}

function resolveClassName(className, isActive = false) {
  if (typeof className === "function") {
    return className({ isActive });
  }
  return className || "";
}

function isModifiedClick(event) {
  return (
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    event.button !== 0
  );
}

export function SiteNavLink({
  to,
  className,
  activeClassName = " is-active",
  onClick,
  children,
  ...rest
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const targetPath = typeof to === "string" ? to.split("?")[0] : to.pathname || to;

  const handleClick = (event) => {
    onClick?.(event);
    if (event.defaultPrevented || isModifiedClick(event)) return;

    if (IS_LANDING) {
      scrollToTopInstant();
      return;
    }

    if (location.pathname !== targetPath) {
      event.preventDefault();
      navigate(to);
      return;
    }

    scrollToTopInstant();
  };

  if (IS_LANDING) {
    return (
      <a
        href={getNavHref(to)}
        className={resolveClassName(className, false)}
        onClick={handleClick}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <NavLink
      to={to}
      onClick={handleClick}
      className={({ isActive }) =>
        typeof className === "function"
          ? className({ isActive })
          : `${className || ""}${isActive ? activeClassName : ""}`
      }
      {...rest}
    >
      {children}
    </NavLink>
  );
}

export function SiteBrandLink({ to = "/", className, onClick, children, ...rest }) {
  const navigate = useNavigate();
  const location = useLocation();
  const targetPath = typeof to === "string" ? to.split("?")[0] : to.pathname || to;

  const handleClick = (event) => {
    onClick?.(event);
    if (event.defaultPrevented || isModifiedClick(event)) return;

    if (IS_LANDING) {
      scrollToTopInstant();
      return;
    }

    if (location.pathname !== targetPath) {
      event.preventDefault();
      navigate(to);
      return;
    }

    scrollToTopInstant();
  };

  if (IS_LANDING) {
    return (
      <a href={getNavHref(to)} className={className} onClick={handleClick} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <NavLink to={to} onClick={handleClick} className={className} {...rest}>
      {children}
    </NavLink>
  );
}
